<template>
  <div id="fb-fanpage-page">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-facebook"></i> Facebook Fanpage
      <i
        class="bi bi-question-circle text-blue"
        v-tooltip.right="{ ref: 'fbHelper' }"
      ></i>
      <button
        v-if="isAdmin"
        id="tambah-fanpage"
        class="btn btn-icon-left btn-success pull-right"
        @click="addFanpage"
      >
        <i class="bi bi-plus"></i> Tambah Fanpage
      </button>
    </h6>
    <div ref="fbHelper" class="tooltip-content">
      <p>
        Daftar <b>Facebook Fanpage</b> yang akan dimonitor. Masukan akun
        Facebook Fanpage yang ingin Anda monitor datanya pada section ini.
      </p>
    </div>

    <p style="text-align: justify">
      <i class="bi bi-info-circle text-blue"></i> Berikut merupakan daftar
      halaman facebook yang akan menjadi sumber data yang akan dikumpulkan.
      Selain data pada tabel dibawah, data juga akan diambil dari daftar
      <a href="javascript:void(0)" @click="showFacebookDefault">
        Halaman Facebook Default </a
      >.
    </p>

    <div class="table-wrapper">
      <table
        class="table table-hover table-condensed"
        id="daftar-fanpage"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>Fanpage</th>
            <th v-if="isAdmin" width="10%" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :static="modal.backdrop"
    />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_facebook_fanpage from "@/views/components/settings/keyword/modal_add_facebook_fanpage.vue";
import swal from "sweetalert";
import facebook_page from "@/views/components/settings/keyword/facebook_page.vue";

export default {
  name: "tab_facebook_fanpage",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      tour_steps: [],
      modal: null,
      modal_key: 0,
      table: null,
      data_fb: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
    };
  },
  methods: {
    getFB: function () {
      let api = process.env.VUE_APP_API_URL + "fb-page/" + this.id_project;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.data_fb = response.data;
          this.generateTable("#daftar-fanpage", this.data_fb);
        } else {
          this.generateTable("#daftar-fanpage", []);
        }
      });
    },
    addFanpage: function () {
      this.modal = {
        title: "Tambah Halaman Facebook",
        subtitle:
          "Silahkan masukan nama halaman facebook kemudian tekan tombol cari",
        component: modal_add_facebook_fanpage,
        backdrop: true,
      };
      this.modal_key++;
    },
    deleteFB: function (page_id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Anda akan menghapus halaman fabebook tersebut dari daftar halaman facebook yang diambil datanya.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: this.id_project,
            page: parseInt(page_id),
          };
          let api = process.env.VUE_APP_API_URL + "fb-page-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Halaman Facebook berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                self.getFB();
              }
            })
            .catch(function () {
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus Halaman Facebook.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    generateTable: function (id, data) {
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [{ data: "hashtag" }, { data: "action" }],
          columnDefs: [
            {
              render: function (data, type, row) {
                return (
                  '<a href="https://facebook.com/' +
                  row.id_page +
                  '" target="__blank">' +
                  row.name +
                  "</a>"
                );
              },
              targets: 0,
            },
            {
              render: function (data, type, row) {
                let btn =
                  '<center><button id="hapus-fanpage" class="btn btn-danger btn-sm del" data-id="' +
                  row.id_page +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 1,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [{ data: "hashtag" }],
          columnDefs: [
            {
              render: function (data, type, row) {
                return (
                  '<a href="https://facebook.com/' +
                  row.id_page +
                  '" target="__blank">' +
                  row.name +
                  "</a>"
                );
              },
              targets: 0,
            },
          ],
        });
      }
    },
    showFacebookDefault: function () {
      this.modal = {
        title: "Daftar Halaman Facebook",
        subtitle:
          "Berikut ini adalah daftar halaman facebook yang otomatis dikumpulkan datanya",
        component: facebook_page,
        backdrop: false,
      };
      this.modal_key++;
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }
      return false;
    },
  },
  mounted: function () {
    this.getFB();
    let self = this;
    this.$("#daftar-fanpage tbody").on("click", ".del", function () {
      let id = self.$(this).attr("data-id");
      self.deleteFB(id);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tab-vertical",
      header: {
        title: "Tab Menu",
      },
      content: `Anda dapat memilih salah satu untuk melihat detail dari menu.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#tambah-fanpage",
      header: {
        title: "Tombol Tambah Fanpage",
      },
      content: `Klik untuk menambahkan data facebook fanpage baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#daftar-fanpage_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari facebook fanpage yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#daftar-fanpage",
      header: {
        title: "Tabel Facebook Fanpage",
      },
      content: `Menampilkan daftar facebook fanpage tersedia.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#hapus-fanpage",
      header: {
        title: "Tombol hapus Fanpage",
      },
      content: `Klik untuk menghapus facebook fanpage yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>